import Head from 'next/head'
import React, { useState } from 'react'
import { Modal } from 'react-components/atoms'
import {
  LandingRivisteHero,
  LandingRivisteCartacea,
  LandingRivisteDigitale,
  LandingRivisteNovita,
  LandingRivisteMotivi,
  LandingRivisteCta,
} from 'react-components/organisms'

const LandingRivisteTemplate = props => {
  const { rivista = undefined, page = undefined, className = '' } = props
  const [zoomModalItem, setZoomModalItem] = useState(null)

  const productCode =
    rivista.slug === 'vita-scolastica'
      ? 'vs'
      : rivista.slug === 'scuola-dellinfanzia'
      ? 'si'
      : rivista.slug === 'psicologia-e-scuola'
      ? 'ps'
      : 'vs'

  const data =
    productCode === 'vs'
      ? {
          color: 'blue',
          hero: {
            productCode: productCode,
            titolo: 'La rivista fatta dagli insegnanti, per gli insegnanti',
            assetImage: `/images/landing-riviste/${productCode}/asset.png`,
            coverImage: `/images/landing-riviste/${productCode}/cover.png`,
          },
          cartacea: {
            item: {
              name: 'Rivista cartacea',
              description:
                '<p>Con <strong>La Vita Scolastica</strong> hai tutto quello che serve per il tuo lavoro a scuola!</p>',
              children: [
                {
                  pk: 1,
                  name: 'Lezioni',
                  image: `/images/landing-riviste/${productCode}/lezione.png`,
                  description:
                    '<p>Le <strong>Lezioni passo passo</strong> ti guidano nel costruire percorsi di apprendimento con tutti i materiali necessari (testi, video, esercizi, attività, e anche la valutazione!)</p>',
                },
                {
                  pk: 2,
                  name: 'Laboratori',
                  image: `/images/landing-riviste/${productCode}/laboratorio.png`,
                  description:
                    '<p>Con i laboratori organizza tante attività pratiche da svolgere in aula... Fare è il modo migliore di imparare!</p>',
                },
                {
                  pk: 3,
                  name: 'Articoli',
                  image: `/images/landing-riviste/${productCode}/articolo.png`,
                  description:
                    '<p>Gli articoli delle nostre grandi firme ti aggiornano sui temi di attualità della scuola.</p>',
                },
                {
                  pk: 4,
                  name: 'Schede',
                  image: `/images/landing-riviste/${productCode}/schede.jpg`,
                  description:
                    '<p>Le schede sono gli strumenti più agili per l’allenamento dei bambini e delle bambine. Ne hai più di 100 diverse ogni mese!</p>',
                },
              ],
            },
          },
          digitale: {
            item: {
              name: 'Abbonamento digitale',
              description:
                "<p>Il tuo abbonamento comprende anche <strong>io+</strong>, il servizio digitale di giuntiscuola.it, con l'accesso a oltre 35.000 risorse per il tuo lavoro... in continuo aggiornamento!</p>",
              children: [
                {
                  pk: 1,
                  name: 'Lezioni interattive',
                  image: `/images/landing-riviste/${productCode}/lezione_digitale.png`,
                  description:
                    '<p>Una marcia in più per le tue lezioni: video, giochi interattivi, tante schede in più...</p>',
                },
                {
                  pk: 2,
                  name: 'Pagine speciali',
                  image: `/images/landing-riviste/${productCode}/valutazione.png`,
                  description:
                    "<p>Raccolte a tema di materiali per le verifiche, la progettazione, l'INVALSI, la valutazione e molto altro...</p>",
                },
                {
                  pk: 3,
                  name: 'Sportello esperti',
                  image: `/images/landing-riviste/sportello_esperti.png`,
                  disableZoom: true,
                  description:
                    '<p>I nostri consulenti rispondono alle tue domande su scuola e famiglia, normativa, didattica, psicologia... per insegnanti e genitori.</p>',
                },
              ],
            },
            contribuisciItem: {
              name: 'Contribuisci anche tu!',
              description:
                '<p>Mandaci i materiali che hai realizzato a scuola: arricchiranno il grande mondo di <strong>La Vita scolastica | io+</strong>.</p>' +
                '<p>Scrivi a <a href="mailto:vitascol@giunti.it">vitascol@giunti.it</a></p>',
            },
          },
          novita: {
            item: {
              name: 'Le novità dell’anno scolastico 2022-23',
              children: [
                {
                  pk: 1,
                  name: 'Grammatica per tutti',
                  color: 'blue-default',
                  description: '<p>Inclusiva e pensata anche per prepararsi alle INVALSI.</p>',
                },
                {
                  pk: 2,
                  name: 'Life Skills e Piano Rigenerazione Scuola',
                  color: 'white',
                  description: '<p>I laboratori su emozioni, cittadinanza, ecologia...</p>',
                },
                {
                  pk: 3,
                  name: 'STEAM',
                  color: 'orange-dark',
                  description:
                    '<p>Laboratori di Scienze e Tecnologia con video tutoriale di Arte.</p>',
                },
                { pk: 4, image: '/images/landing-riviste/vs/piumini_roberto-2.png' },
                {
                  pk: 5,
                  name: 'A domande rispondo!',
                  color: 'primary',
                  description:
                    '<p><strong>Roberto Piumini</strong> inaugura la nuova rubrica di parole e poesia, in dialogo con i bambini e le bambine.</p>',
                },
              ],
            },
          },
          motivi: {
            item: {
              name: 'Mi abbono a <span>La Vita Scolastica</span> perché...',
              children: [
                {
                  pk: 1,
                  description:
                    '<p>... posso aggiornarmi in tempo reale su tutte le novità del mondo scuola, con strumenti concreti per metterle in pratica in classe.</p>',
                },
                {
                  pk: 2,
                  description:
                    '<p>... ho un supporto concreto da chi conosce il mondo scuola: La Vita Scolastica parla la mia lingua perché è fatta dagli insegnanti, supportati dai migliori esperti.</p>',
                },
                {
                  pk: 3,
                  description:
                    "<p>... è un'occasione di formazione continua e di qualità: webinar, corsi, convegni, laboratori online inclusi nel mio abbonamento.</p>",
                },
                {
                  pk: 4,
                  description:
                    "<p>... mi fa risparmiare tempo: con La Vita Scolastica ho tutti i materiali pronti all'uso per le mie lezioni!</p>",
                },
              ],
            },
          },
          cta: {
            item: {
              name: 'Insomma, cosa aspetti?',
              image: `/images/landing-riviste/${productCode}/cover.png`,
              description:
                '<p>La Vita Scolastica da oltre 70 anni è al fianco di tutti gli insegnanti.</p>', // <strong>Vuoi conoscerla meglio?</strong> Scarica "Almanacco 2022", con il meglio dell\'anno appena passato.</p>',
              children: [
                {
                  pk: 1,
                  name: 'Abbonati subito',
                  url: '/riviste/vita-scolastica',
                },
                // { pk: 2, name: 'Scarica il pdf', url: `/` },
              ],
            },
          },
        }
      : productCode === 'si'
      ? {
          color: 'green',
          hero: {
            productCode: productCode,
            titolo: 'La rivista per chi lavora con i bambini e le bambine di 0-6 anni',
            assetImage: `/images/landing-riviste/${productCode}/asset.png`,
            coverImage: `/images/landing-riviste/${productCode}/cover.png`,
          },
          cartacea: {
            item: {
              name: 'Rivista cartacea',
              description:
                '<p>Con <strong>Scuola dell’infanzia</strong> hai tutto quello che serve per il tuo lavoro quotidiano.</p>',
              children: [
                {
                  pk: 1,
                  name: 'Percorsi',
                  image: `/images/landing-riviste/${productCode}/percorsi_SI.png`,
                  description:
                    '<p>Usa i <strong>percorsi</strong> per campi di esperienza e linguaggi, con tutti i materiali necessari: giochi, video, idee per fare, suggerimenti di lettura...</p>',
                },
                {
                  pk: 2,
                  name: 'Laboratori',
                  image: `/images/landing-riviste/${productCode}/laboratori_SI.png`,
                  description:
                    '<p>Organizza tante attività pratiche, giochi, esperimenti, musica, teatro... Fare è il modo migliore di imparare!</p>',
                },
                {
                  pk: 3,
                  name: 'Articoli',
                  image: `/images/landing-riviste/${productCode}/articoli_SI.png`,
                  description:
                    '<p>Non perdere il filo dell’attualità sui temi caldi della scuola: segui gli <strong>articoli</strong> delle nostre grandi firme.</p>',
                },
                {
                  pk: 4,
                  name: 'Materiali',
                  image: `/images/landing-riviste/${productCode}/materiali_SI.png`,
                  description:
                    '<p>Scegli fra centinaia di schede, video, audio quelli più adatti per lavorare e divertirti con i bambini e le bambine!</p>',
                },
              ],
            },
          },
          digitale: {
            item: {
              name: 'Abbonamento digitale',
              description:
                "<p>Il tuo abbonamento comprende anche <strong>io+</strong>, il servizio digitale di giuntiscuola.it, con l'accesso a oltre 35.000 risorse per il tuo lavoro... in continuo aggiornamento!</p>",
              children: [
                {
                  pk: 1,
                  name: 'Percorsi interattivi',
                  image: `/images/landing-riviste/${productCode}/percorsi_interattivi_SI.png`,
                  description:
                    '<p>Una marcia in più per il tuo lavoro: video, giochi interattivi, tanti materiali in più...</p>',
                },
                {
                  pk: 2,
                  name: 'Pagine speciali',
                  image: `/images/landing-riviste/${productCode}/pace.png`,
                  description:
                    '<p>Raccolte a tema sugli argomenti, le ricorrenze, i momenti legati al mondo dell’infanzia.</p>',
                },
                {
                  pk: 3,
                  name: 'Sportello esperti',
                  disableZoom: true,
                  image: `/images/landing-riviste/sportello_esperti.png`,
                  description:
                    '<p>I nostri consulenti rispondono alle tue domande su scuola e famiglia, normativa, didattica, psicologia... per insegnanti e genitori.</p>',
                },
              ],
            },
            contribuisciItem: {
              name: 'Contribuisci anche tu!',
              description:
                '<p>Mandaci i materiali che hai realizzato a scuola: arricchiranno il grande mondo di <strong>Scuola dell’infanzia | io+</strong>.</p>' +
                '<p>Scrivi a <a href="mailto:scuolainfanzia@giunti.it">scuolainfanzia@giunti.it</a></p>',
            },
          },
          novita: {
            item: {
              name: 'Le novità dell’anno scolastico 2022-23',
              children: [
                {
                  pk: 1,
                  name: 'Progetto annuale 0-6',
                  color: 'green-default',
                  description:
                    '<p>Su emozioni, relazioni e Life skills attraverso il gioco del teatro</p>',
                },
                {
                  pk: 2,
                  name: 'L’angolo in festa',
                  color: 'white',
                  description:
                    '<p>Le pagine speciali dedicate alle festività e alle "Giornate",con artefatti, giochi e molto altro.</p>',
                },
                {
                  pk: 3,
                  name: "Laboratori d'Arte",
                  color: 'blue-dark',
                  description: "<p>Video-tutorial con un focus sull'arte contemporanea.</p>",
                },
              ],
            },
          },
          motivi: {
            item: {
              name: "Mi abbono a <span>Scuola dell'infanzia</span> perché...",
              children: [
                {
                  pk: 1,
                  description:
                    '<p>... posso aggiornarmi in tempo reale su tutte le novità del mondo scuola, con strumenti concreti per metterle in pratica in sezione.</p>',
                },
                {
                  pk: 2,
                  description:
                    '<p>... ho un supporto concreto da chi conosce il mondo scuola: Scuola dell’infanzia parla la mia lingua perché è fatta dagli insegnanti, supportati dai migliori esperti.</p>',
                },
                {
                  pk: 3,
                  description:
                    "<p>... è un'occasione di formazione continua e di qualità: webinar, corsi, convegni, laboratori online inclusi nel mio abbonamento.</p>",
                },
                {
                  pk: 4,
                  description:
                    "<p>... mi fa risparmiare tempo: con Scuola dell’infanzia ho tutti i materiali pronti all'uso per le mie attività!</p>",
                },
              ],
            },
          },
          cta: {
            item: {
              name: 'Insomma, cosa aspetti?',
              image: `/images/landing-riviste/${productCode}/cover.png`,
              description:
                '<p>Scuola dell’infanzia da oltre 20 anni è al fianco di tutti gli insegnanti.</p>', // <strong>Vuoi conoscerla meglio?</strong> Scarica "Almanacco 2022", con il meglio dell\'anno appena passato.</p>',
              children: [
                {
                  pk: 1,
                  name: 'Abbonati subito',
                  url: '/riviste/scuola-dellinfanzia',
                },
                // { pk: 2, name: 'Scarica il pdf', url: `/` },
              ],
            },
          },
        }
      : productCode === 'ps'
      ? {
          color: 'yellow',
          hero: {
            productCode: productCode,
            titolo: 'La rivista per star bene a scuola',
            assetImage: `/images/landing-riviste/${productCode}/asset.png`,
            coverImage: `/images/landing-riviste/${productCode}/cover.png`,
          },
          cartacea: {
            item: {
              name: 'Rivista cartacea',
              description:
                '<p>Con <strong>Psicologia e scuola</strong> hai quello che ti serve per il lavoro e il benessere a scuola.</p>',
              children: [
                {
                  pk: 1,
                  name: 'Il Tema',
                  image: `/images/landing-riviste/${productCode}/tema_PS.png`,
                  description:
                    '<p>In ogni numero un <strong>approfondimento tematico</strong> a cura dei migliori esperti della psicologia e dell’educazione.</p>',
                },
                {
                  pk: 2,
                  name: 'Star bene insieme',
                  image: `/images/landing-riviste/${productCode}/star_bene.png`,
                  description:
                    '<p>Il rapporto con i colleghi, le relazioni con i bambini, le storie degli adolescenti… i suggerimenti per creare un buon clima di classe.</p>',
                },
                {
                  pk: 3,
                  name: 'Inclusione',
                  image: `/images/landing-riviste/${productCode}/inclusione.png`,
                  description:
                    '<p>Approfondimenti su BES, DSA, sostegno, disabilità. Con la consulenza di Cesare Cornoldi.</p>',
                },
                {
                  pk: 4,
                  name: 'Laboratori',
                  image: `/images/landing-riviste/${productCode}/laboratori_PS.png`,
                  description:
                    '<p>Giochi, attività concrete, esperimenti per vincere la paura, gestire le emozioni, star bene.</p>',
                },
              ],
            },
          },
          digitale: {
            item: {
              name: 'Abbonamento digitale',
              description:
                "<p>Il tuo abbonamento comprende anche <strong>io+</strong>, il servizio digitale di giuntiscuola.it, con l'accesso a oltre 35.000 risorse per il tuo lavoro... in continuo aggiornamento!</p>",
              children: [
                {
                  pk: 1,
                  name: 'Video',
                  image: `/images/landing-riviste/${productCode}/video.png`,
                  description:
                    '<p>Pillole, contributi e webinar a cura del team di Psicologia e scuola: Lusia Lauretta, Cesare Cornoldi e molti altri. </p>',
                },
                {
                  pk: 2,
                  name: 'Pagine speciali',
                  image: `/images/landing-riviste/${productCode}/valutazione.png`,
                  description:
                    '<p>Raccolte a tema di materiali per la progettazione, la valutazione, l’inclusione e molto altro...</p>',
                },
                {
                  pk: 3,
                  name: 'Sportello esperti',
                  disableZoom: true,
                  image: `/images/landing-riviste/sportello_esperti.png`,
                  description:
                    '<p>I nostri consulenti rispondono alle tue domande su scuola e famiglia, autismo, relazioni psicologia... per insegnanti e genitori.</p>',
                },
              ],
            },
            contribuisciItem: {
              name: 'Contribuisci anche tu!',
              description:
                '<p>Mandaci i materiali che hai realizzato a scuola: arricchiranno il grande mondo di <strong>Psicologia e scuola | io+</strong>.</p>' +
                '<p>Scrivi a <a href="mailto:vitascol@giunti.it">vitascol@giunti.it</a></p>',
            },
          },
          novita: {
            item: {
              name: 'Le novità dell’anno scolastico 2022-23',
              children: [
                {
                  pk: 1,
                  name: 'Life Skills',
                  color: 'yellow-default',
                  description:
                    '<p>Approfondimenti su tutti gli aspetti legati a emozioni, relazioni e area cognitiva.</p>',
                },
                {
                  pk: 2,
                  name: 'Scuola Famiglia',
                  color: 'white',
                  description:
                    '<p>Una rubrica a cura di Giunti Edu per rafforzare l’alleanza con i genitori.</p>',
                },
                {
                  pk: 3,
                  color: 'blue-dark',
                  name: 'Bullismo e Cyberbullismo',
                  description:
                    '<p>Un progetto speciale per sensibilizzare i bambini su un tema fondamentale.</p>',
                },
              ],
            },
          },
          motivi: {
            item: {
              name: 'Mi abbono a <span>Psicologia e scuola</span> perché...',
              children: [
                {
                  pk: 1,
                  description:
                    '<p>... ho tutto il meglio della ricerca psicopedagogica tradotto in termini semplici, efficaci e accessibili per il mio lavoro a scuola.</p>',
                },
                {
                  pk: 2,
                  description:
                    '<p>... ho un supporto concreto da chi conosce il mondo scuola: Psicologia e scuola parla la mia lingua perché è fatta dagli insegnanti, supportati dai migliori esperti.</p>',
                },
                {
                  pk: 3,
                  description:
                    "<p>... è un'occasione di formazione continua e di qualità: webinar, corsi, convegni, laboratori online inclusi nel mio abbonamento.</p>",
                },
                {
                  pk: 4,
                  description:
                    '<p>... posso aggiornarmi in tempo reale sulle novità più importanti della psicologia a scuola attraverso i pareri di esperti autorevoli come Cesare Cornoldi e Luisa Lauretta.</p>',
                },
              ],
            },
          },
          cta: {
            item: {
              name: 'Insomma, cosa aspetti?',
              image: `/images/landing-riviste/${productCode}/cover.png`,
              description:
                '<p>Psicologia e scuola da oltre 20 anni è al fianco di tutti gli insegnanti.</p>', //<strong>Vuoi conoscerla meglio?</strong> Scarica "Almanacco 2022", con il meglio dell\'anno appena passato.</p>',
              children: [
                {
                  pk: 1,
                  name: 'Abbonati subito',
                  url: '/riviste/psicologia-e-scuola',
                },
                // { pk: 2, name: 'Scarica il pdf', url: `/` },
              ],
            },
          },
        }
      : undefined

  return (
    <main
      className={`landing-riviste-template landing-riviste-template--${data.color} ${
        className ? ` ${className}` : ''
      }`}
    >
      <Head>
        <title>{data.hero.titolo} | Giunti Scuola</title>
      </Head>
      <LandingRivisteHero productCode={productCode} {...data.hero} />
      <LandingRivisteCartacea
        productCode={productCode}
        {...data.cartacea}
        setZoomModalItem={setZoomModalItem}
      />
      <LandingRivisteDigitale {...data.digitale} setZoomModalItem={setZoomModalItem} />
      <LandingRivisteNovita {...data.novita} />
      <LandingRivisteMotivi {...data.motivi} />
      <LandingRivisteCta {...data.cta} />
      <Modal
        open={!!zoomModalItem?.image}
        setOpen={v => {
          if (!v) {
            document.body.classList.remove('w-scrolldown')
            setZoomModalItem(null)
          }
        }}
        closeButton={true}
        className="wmodal--lightbox landing-riviste-slider__zoom-modal"
      >
        {!!zoomModalItem?.image && (
          <img src={zoomModalItem.image} alt={zoomModalItem.name} title={zoomModalItem.name} />
        )}
      </Modal>
    </main>
  )
}

export default LandingRivisteTemplate
